import _ from 'lodash'
import ExAnteStep from "./components/StepContent/components/step/ExAnteStep";
import {aggregatePortfoliosExAnte} from "../Trades/utils";
import {BankSettingsHandlerResource} from "../../utils/api";
import {Service} from "./service";

import ExAnteStepV2 from "./components/StepContent/components/step/ExAnteStepV2";
import {
  CONFIRMATION_STATE,
  EX_ANTE_STEP_NAME,
  FIELD_REQUIRED_MSG,
  PRODUCT_SELECTION_SUMMARY_STEP_ID
} from "./constants";
import {store} from "../../store";
import {displayErrorSnackBar} from "../../components/SnackbarProvider/actions";

const getExAnteStepsData = () => ({
  steps: [
    {
      "uid": "ex-ante-step",
      "name": "Ex-Ante Kosten",
      "behaviour": ["dynamic"],
      "category": "Ex-Ante Kosten",
      "custom_classes": {"stepName": "text-left"},
      "step_content": ExAnteStep,
      "question": [
        {
          "uid": "ex_ante",
          "type": "input",
          "isValid": function() {
            return !_.isEmpty(this.answer);
          }
        }
      ]
    }
  ]
});

const getExAnteStepsDataV2 = () => ({
  steps: [
    {
      "uid": "ex-ante-step",
      "name": EX_ANTE_STEP_NAME,
      "behaviour": ["dynamic"],
      "category": "Ex-Ante Kosten",
      "custom_classes": {"stepName": "text-left"},
      "step_content": ExAnteStepV2,
      "no_user_input": true,
      "dependsOn": [
        {menu: 'products_selection', step: 'product-selection-depot'},
        {menu: 'products_selection', step: 'product-selection-depot-type'},
        {menu: 'products_selection', step: 'product-selection-depot-opening-type'},
        {menu: 'products_selection', step: 'product-selection-investment-recommendation'},
        {menu: 'products_selection', step: PRODUCT_SELECTION_SUMMARY_STEP_ID},
      ],
      "question": [
        {
          "uid": "ex_ante",
          "type": "input",
          "isValid": function() {
            const error = _.isEmpty(this.answer) && FIELD_REQUIRED_MSG;

            if(error){
              store.dispatch(displayErrorSnackBar(error))
              return false
            }

            return true;
          }
        }
      ]
    }
  ]
});

export class ExAnteService extends Service {
  constructor(uid, name, customer_id, getPrevStepService) {
    super(uid, name, null, null);
    this._customer_id = customer_id;
    this._getStepService = getPrevStepService;
    this._getPrevStepAnswer = (onboarind_step_uid, step_uid, question_uid, withOption) => {
      const menu = this._getStepService(onboarind_step_uid);
      if(menu){
        return menu.getStepAnswer(step_uid, question_uid, withOption);
      }
    };
    this.hideSideMenu = true;
  }

  _getExAnteRequest = async (requestBody, simulationYears) => {
    const data = {...requestBody, simulating_years: simulationYears};

      const response =
        this.isNewDesign && !requestBody['depot_type_id']
          ? {}
          : await BankSettingsHandlerResource.getExAnteCalculation(data);

    return {
      portfolioId: 'onboarding',
      bankCode: data.bank,
      simulationYears,
      response
    }
  };

  getExAnteData = async () => {
    const dataService = this._getStepService('products_selection');
    const modelPortfolio = dataService.getStepAnswer('product-selection-investment-recommendation', 'instruments_source');

    const exAnteRequest = dataService.getDataForAccount(true, true);
    exAnteRequest['depot_type_id'] = dataService.isNewDesign
      ? dataService.getStepAnswer('product-selection-depot-type', 'depot-type')
      : dataService.getStepAnswer('product-selection-depot', 'custodians').contract_type;
    exAnteRequest['session_id'] = dataService.__onboarding_uid;

    let instrumentSourceKey = undefined;
    let instrumentSourceId = undefined;
    if (modelPortfolio) {
      instrumentSourceId = _.get(modelPortfolio, 'id');
      if (modelPortfolio.isInvestmentStrategy) {
        instrumentSourceKey = 'investment_strategy_id'
      } else if (modelPortfolio.is_modelportfolio) {
        instrumentSourceKey = 'model_portfolio_id'
      }
    } else if (dataService.isIndividualAssetManagementProcess()){
      exAnteRequest.individual_asset_management = true;
    }

    if (instrumentSourceKey) {
      exAnteRequest[instrumentSourceKey] = instrumentSourceId
    }

    const exAnteStep = this._questionnaire.steps[0];
    const exAnteQuestion = exAnteStep.question[0];

    if(exAnteStep.confirmationState === CONFIRMATION_STATE.CONFIRMED){
      exAnteStep.confirmationState = undefined;
    }
    exAnteQuestion.error = null; // clean error
    exAnteQuestion.answer = null;  // clean prev answer

    try {
      const res = await this._getExAnteRequest(exAnteRequest, 5);

      if(!this.isNewDesign || !_.isEmpty(res.response) || dataService.isOpenOnly) {
        exAnteQuestion.answer = aggregatePortfoliosExAnte([res], true);
      }
    } catch (e) {
      await this.__setStep(null, 0);

      exAnteQuestion.error = e;
    }
  };

  async __setQuestionnaire(defaultAnswers, initOnly){
    await super.__setQuestionnaire(defaultAnswers, initOnly);
    this._questionnaire =
      this.isNewDesign || this._getStepService('products_selection').isIndividualAssetManagementProcess()
        ? getExAnteStepsDataV2()
        : getExAnteStepsData();

    this._setDefaultAnswers(defaultAnswers);

    // get ExAnte data if not restore progress or answer is missing
    if(!initOnly || _.isEmpty(this._questionnaire.steps[0].question[0].answer)){
      await this.getExAnteData()
    }
  }
}
